import React, {useEffect, useRef, useState} from 'react';
import Section from "../../components/section";
import HelperService from "../../services/helper-service";
import MainLayout from "../../layouts/main";
import {useGlobalNotificationMessage} from "../../context/message";
import PageTitle from "../../components/page-title";
import DataTableBase from "../../components/datatable/data-table-base";
import {useMembershipShareService} from "../../services/membership-share-service";

export default function MembershipSharesList () {
  let membershipShareService = useMembershipShareService();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(()=>{
    membershipShareService.getList()
      .then((rows)=>{
        setRows(rows);
        setLoaded(true);
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa získať dáta.");
      })
  }, []);

  const columns = [{
      name: 'Člen',
      selector: row => row.user?.name,
      sortable: true,
    },{
      name: 'Hodnota celkom',
      selector: row => row?.sum_values,
      sortable: true,
    },{
      name: 'Počet záznamov',
      selector: row => row?.count_values,
      sortable: true,
    }
  ];

  return (
    <>
      <Section animation={HelperService.getRandomAnimation()}>
        <div className="container mt-4">

          <PageTitle>Členské podiely</PageTitle>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                 <DataTableBase
                    progressPending={!loaded}
                    columns={columns}
                    data={rows}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}

MembershipSharesList.getLayout = function getLayout(page) {
  return (
    <MainLayout>
      {page}
    </MainLayout>
  )
}

MembershipSharesList.getSEO = function getSEO() {
  return {
    title: "Členské podiely",
  }
}
